import {
  Label,
  SingleSelectDropdown,
} from "@monsterindia/global-ui-components";
import { memo } from "react";
import { Controller } from "react-hook-form";

import { DropdownOptionType } from "../../../../../../types";
import { LgbtqiaApopControllerType } from "../../../../../../types/apop";
import { ErrorText } from "../../../../common/ErrorText";

type DropDownControllerProps = {
  options: DropdownOptionType[];
  isLoading?: boolean;
} & LgbtqiaApopControllerType;

const DropDownController = ({
  name,
  label,
  control,
  errors,
  options,
  setIsUserInput,
  isLoading,
}: DropDownControllerProps) => {
  return (
    <div className="l1-w-full">
      <Label className="l1-flex p-0" labelText={label} isRequired>
        <Controller
          name={name}
          control={control}
          rules={{ required: "This field is required" }}
          render={({ field }) => {
            return (
              <>
                <SingleSelectDropdown
                  id={name}
                  width="l1-w-full"
                  placeholder={label}
                  isSearchable={false}
                  options={options}
                  loadingText={
                    options.length === 0 && !isLoading
                      ? "No options available"
                      : "Loading..."
                  }
                  selectedValue={
                    options.find((option) => option?.id === field?.value?.id) ??
                    null
                  }
                  handleDropdownSelect={(selected: DropdownOptionType) => {
                    if (selected) {
                      setIsUserInput({ key: name, value: `${selected?.id}` });
                      field.onChange(selected);
                    }
                  }}
                  disabled={options?.length > 0 ? false : true}
                  {...field}
                />
                {errors[name] && (
                  <ErrorText
                    text={errors[name]?.message || "This field is required"}
                  />
                )}
              </>
            );
          }}
        />
      </Label>
    </div>
  );
};

export default memo(DropDownController);
